// Module
var code = `
<ul class="blog-menu-list">

{{#links}}

<li class="blog-menu-list-item">

<a data-channel="ROUTE" data-event-prevent-default="true" data-page-id="{{pageId}}" data-section="{{section}}" href="{{attrHref}}"  alt="" >
    <div class="blog-img-holder">
        <img src="{{imgSrc}}" alt="" />
    </div>

    <span>{{title}}</span></a>
</li>

{{/links}}
</ul>
`;
// Exports
module.exports = code;